import React from "react";
import PropTypes from "prop-types";

// Time until the board resets, e.g. "5h 12m". Boards are per UTC day so
// everyone everywhere is on the same one.
export function timeUntilReset(now = new Date()) {
  const reset = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1);
  const minutes = Math.max(0, Math.floor((reset - now.getTime()) / 60000));
  return `${Math.floor(minutes / 60)}h ${minutes % 60}m`;
}

export default function Leaderboard({ board, compact }) {
  if (!board) return null;

  const { players, top, you } = board;
  const youInTop = top.some((row) => row.you);

  if (!top.length) {
    return <p className="gar-board-empty">Nobody on today’s board yet. The first run takes it.</p>;
  }

  return (
    <div className="gar-board">
      <ol className="gar-board-list">
        {(compact ? top.slice(0, 3) : top).map((row) => (
          <li className={row.you ? "gar-board-row gar-board-you" : "gar-board-row"} key={`${row.rank}-${row.username}`}>
            <span className="gar-board-rank">{row.rank}</span>
            <span className="gar-board-name">{row.username}</span>
            <span className="gar-board-score">{row.score}</span>
          </li>
        ))}
      </ol>
      {you && !youInTop && !compact && (
        <p className="gar-board-note">
          You’re #{you.rank} of {players} with {you.score}
        </p>
      )}
      <p className="gar-board-note">Resets at midnight UTC · {timeUntilReset()} left</p>
    </div>
  );
}

Leaderboard.defaultProps = { board: null, compact: false };

Leaderboard.propTypes = {
  board: PropTypes.shape({
    players: PropTypes.number,
    top: PropTypes.arrayOf(
      PropTypes.shape({
        rank: PropTypes.number,
        score: PropTypes.number,
        username: PropTypes.string,
        you: PropTypes.bool,
      })
    ),
    you: PropTypes.shape({ rank: PropTypes.number, score: PropTypes.number }),
  }),
  compact: PropTypes.bool,
};
